(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-mg-card]')];
    const select = root.querySelector('[data-mg-availability]');
    const apply = () => {
      let total = 0;
      cards.forEach(card => {
        card.hidden = !(select.value === 'all' || card.dataset.group === select.value);
        if (!card.hidden) total++;
      });
      root.querySelectorAll('[data-mg-group]').forEach(group => {
        const count = [...group.querySelectorAll('[data-mg-card]')].filter(card => !card.hidden).length;
        group.hidden = count === 0;
        group.querySelector('[data-mg-group-count]').textContent = count;
      });
      root.querySelector('[data-mg-count]').textContent = total;
      root.querySelector('[data-mg-empty]').hidden = total !== 0 || cards.length === 0;
    };
    select.addEventListener('change', apply);
    root.querySelector('[data-mg-controls]').hidden = false;
    apply();
  };
  const scan = () => document.querySelectorAll('[data-mittsu-green]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
